// eslint-disable-next-line
import util from 'util';

// eslint-disable-next-line
import * as actionTypes from '../actionTypes';

const initialState = {
  filters: {
    leads : {
      label: 'Leads',
      active: false,
    },
    currentClients : {
      label: 'Current Clients',
      active: false,
    },
    flagged : {
      label: 'Flagged',
      active: false,
    },
    assists : {
      label: 'Assists',
      active: false,
    },
    inboundCalls : {
      label: 'Inbound Calls',
      active: false,
    },
    outboundCalls : {
      label: 'Outbound Calls',
      active: false,
    },
    messages : {
      label: 'Messages',
      active: false,
    },
    voicemail : {
      label: 'Voicemails',
      active: false,
    },
    // texts: {
    //   label:'Texts',
    //   active: false,
    // },
    unread: {
      label: 'Unread',
      active: false,
    },
    roboCalls: {
      label: 'Robo Calls',
      active: false,
    },
    vip: {
      label: 'VIP Calls',
      active: false,
    },
  },
  chatFilters: {
    actionableSupport: {
      label: 'Actionable Support',
      active: false
    },
    nonActionableSupport: {
      label: 'Non-Actionable Support',
      active: false
    },
    flagged : {
      label: 'Flagged',
      active: false,
    },
    leads : {
      label: 'Leads',
      active: false,
    },
    unread: {
      label: 'Unread',
      active: false,
    },
    spam: {
      label: 'Spam',
      active: false,
    },
  },
  chatFilterListText: "No Filters", 
  filterListText: "No Filters",
  filterType: "all",
  filterDays: "30",
  filterSearch: "",
  showFilterDialog: false,
  filterAccountId: "my",
  filterLocationId: "",
  filterAccounts: [],
  filterLocations: [],
  message: {},
  activityDetailOpen: false,
  contact: {},
  contactOpen: false,
  contactChanged: false,
  activityViewType: "all",
  contactsSearchText: "",
  updatingHoldCalls: false,
  updatingMessages: false,
  updateMessagesAgain: false,
  statusSelectionLists: {},
  status: {},
  statusOpen: false,
  smsTask: { messages: [] },
  sendingSms: false,
  updatingSmsTasks: false,
  updateSmsTasksAgain: false,
  backgroundUpdatingSmsTasks: false,
  transferServices: "",
  messages: { userMessages: [], accountMessages: [], locationMessages: [], pureChats: [] },
  contactLink: {},
  contactLinkOpen: false,
  contactLinkContacts: [],
  assistOpen: false,
  contactLinkMenuAnchor: undefined,
  addContactLink: undefined,
  assistTask: {},
  sendTextOpen: false,
  sourcePhoneNumberId: '',
  textPhoneNumber: '',
  sendingText: false,
  textSearch: '',
  textArchiveFilter: 'all',
  verificationCode:'',
  unreadMessageCount: 0,
  unreadChatCount: 0,
  blockNumbersAccount:[],
  pdfContent: '',
  last20Messages: { userMessages: [], accountMessages: [], locationMessages: [], pureChats: [] },
  messagesLoaded: null,
  showLoading: false,
  vipCallers: [],
  reportFiles: [],
  confirmUnblockNumber: false,
  unblockPhoneNumber: null,
  unblockAccountId: null,
  pureChatStartTime: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
  pureChatEndTime: new Date(),
  callHandlingData: {},
  phoneNumbers: [],
  callForm: null,
  callFormLoading: false,
  aiActions: [],
  aiActionsLoading: false,
  warmTransferEnabled: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_PDF_DATA: {
      return({...state, pdfContent: action.payload.pdfContent });
    }
    case actionTypes.SET_FILTERS : {
      return({...state, filters: action.payload.filters });
    }
    case actionTypes.SET_CHAT_FILTERS : {
      return({...state, chatFilters: action.payload.chatFilters });
    }
    case actionTypes.SET_SHOW_FILTER_DIALOG : {
      return({...state, showFilterDialog: action.payload.showFilterDialog });
    }
    case actionTypes.SET_FILTER_LIST_TEXT : {
      return({...state, filterListText: action.payload.filterListText });
    }
    case actionTypes.SET_CHAT_FILTER_LIST_TEXT : {
      return({...state, chatFilterListText: action.payload.chatFilterListText });
    }
    case actionTypes.SET_FILTER_TYPE : {
      return({...state, filterType: action.payload.filterType });
    }
    case actionTypes.SET_FILTER_DAYS : {
      return({...state, filterDays: action.payload.filterDays });
    }
    case actionTypes.SET_FILTER_SEARCH : {
      return({...state, filterSearch: action.payload.filterSearch });
    }
    case actionTypes.SET_FILTER_ACCOUNT_ID : {
      return({...state, filterAccountId: action.payload.filterAccountId });
    }
    case actionTypes.SET_FILTER_LOCATION_ID : {
      return({...state, filterLocationId: action.payload.filterLocationId });
    }
    case actionTypes.SET_FILTER_ACCOUNTS : {
      return({...state, filterAccounts: action.payload.filterAccounts });
    }
    case actionTypes.SET_FILTER_LOCATIONS : {
      return({...state, filterLocations: action.payload.filterLocations });
    }
    case actionTypes.SET_MESSAGE : {
      return({...state, message: action.payload.message });
    }
    case actionTypes.SET_ACTIVITY_DETAIL_OPEN : {
      return({...state, activityDetailOpen: action.payload.activityDetailOpen });
    }
    case actionTypes.SET_CONTACT : {
      return({...state, contact: action.payload.contact });
    }
    case actionTypes.SET_CONTACT_OPEN : {
      return({...state, contactOpen: action.payload.contactOpen });
    }
    case actionTypes.SET_BLOCK_NUMBERS_ACCOUNT : {
      return({...state, blockNumbersAccount: action.payload.blockNumbersAccount });
    }
    case actionTypes.SET_CONTACT_CHANGED : {
      return({...state, contactChanged: action.payload.contactChanged });
    }
    case actionTypes.SET_ACTIVITY_VIEW_TYPE : {
      return({...state, activityViewType: action.payload.activityViewType });
    }
    case actionTypes.SET_CONTACTS_SEARCH_TEXT : {
      return({...state, contactsSearchText: action.payload.contactsSearchText });
    }
    case actionTypes.SET_UPDATING_HOLD_CALLS : {
      return({...state, updatingHoldCalls: action.payload.updatingHoldCalls });
    }
    case actionTypes.SET_UPDATING_MESSAGES : {
      return({...state, updatingMessages: action.payload.updatingMessages });
    }
    case actionTypes.SET_UPDATE_MESSAGES_AGAIN : {
      return({...state, updateMessagesAgain: action.payload.updateMessagesAgain });
    }
    case actionTypes.SET_STATUS_SELECTION_LISTS : {
      return({...state, statusSelectionLists: action.payload.statusSelectionLists });
    }
    case actionTypes.SET_STATUS : {
      return({...state, status: action.payload.status });
    }
    case actionTypes.SET_STATUS_OPEN : {
      return({...state, statusOpen: action.payload.statusOpen });
    }
    case actionTypes.SET_SMS_TASK : {
      return({...state, smsTask: action.payload.smsTask });
    }
    case actionTypes.SET_SENDING_SMS : {
      return({...state, sendingSms: action.payload.sendingSms });
    }
    case actionTypes.SET_UPDATING_SMS_TASKS : {
      return({...state, updatingSmsTasks: action.payload.updatingSmsTasks });
    }
    case actionTypes.SET_UPDATE_SMS_TASKS_AGAIN : {
      return({...state, updateSmsTasksAgain: action.payload.updateSmsTasksAgain });
    }
    case actionTypes.SET_BACKGROUND_UPDATE_SMS_TASKS : {
      return({...state, backgroundUpdatingSmsTasks: action.payload.backgroundUpdatingSmsTasks });
    }
    case actionTypes.SET_TRANSFER_SERVICES : {
      return({...state, transferServices: action.payload.transferServices });
    }
    case actionTypes.SET_MESSAGES : {
      return({...state, messages: action.payload.messages });
    }
    case actionTypes.SET_CONTACT_LINK : {
      return({...state, contactLink: action.payload.contactLink });
    }
    case actionTypes.SET_CONTACT_LINK_OPEN : {
      return({...state, contactLinkOpen: action.payload.contactLinkOpen });
    }
    case actionTypes.SET_CONTACT_LINK_CONTACTS : {
      return({...state, contactLinkContacts: action.payload.contactLinkContacts });
    }
    case actionTypes.SET_ASSIST_OPEN : {
      return({...state, assistOpen: action.payload.assistOpen });
    }
    case actionTypes.SET_CONTACT_LINK_MENU_ANCHOR : {
      return({...state, contactLinkMenuAnchor: action.payload.contactLinkMenuAnchor });
    }
    case actionTypes.SET_ADD_CONTACT_LINK : {
      return({...state, addContactLink: action.payload.addContactLink });
    }
    case actionTypes.SET_ASSIST_TASK : {
      return({...state, assistTask: action.payload.assistTask });
    }
    case actionTypes.SET_SEND_TEXT_OPEN : {
      return({...state, sendTextOpen: action.payload.sendTextOpen });
    }
    case actionTypes.SET_SOURCE_PHONE_NUMBER_ID : {
      return({...state, sourcePhoneNumberId: action.payload.sourcePhoneNumberId });
    }
    case actionTypes.SET_TEXT_PHONE_NUMBER : {
      return({...state, textPhoneNumber: action.payload.textPhoneNumber });
    }
    case actionTypes.SET_SENDING_TEXT : {
      return({...state, sendingText: action.payload.sendingText });
    }
    case actionTypes.SET_TEXT_SEARCH : {
      return({...state, textSearch: action.payload.textSearch });
    }
    case actionTypes.SET_VERIFICATION_CODE : {
      return({...state, verificationCode: action.payload.verificationCode });
    }
    case actionTypes.SET_UNREAD_MESSAGE_COUNT : {
      return({...state, unreadMessageCount: action.payload.unreadMessageCount });
    }
    case actionTypes.SET_UNREAD_CHAT_COUNT : {
      return({...state, unreadChatCount: action.payload.unreadChatCount });
    }
    case actionTypes.SET_LAST_20_MESSAGES : {
      return({...state, last20Messages: action.payload.last20Messages });
    }
    case actionTypes.UPDATE_SMS_TASK_ARCHIVE_STATUS : {
      const { taskId, archived } = action.payload;
      return {
        ...state,
        last20Messages: {
          ...state.last20Messages,
          smsTasks: state.last20Messages.smsTasks?.map(task => 
            task.taskId === taskId 
              ? { ...task, messageArchived: archived }
              : task
          ) || []
        }
      };
    }
    case actionTypes.SET_MESSAGES_LOADED : {
      return({...state, messagesLoaded: action.payload.messagesLoaded });
    }
    case actionTypes.SET_SHOW_LOADING : {
      return({...state, showLoading: action.payload.showLoading });
    }
    case actionTypes.SET_VIP_CALLERS: {
      return({...state, vipCallers: action.payload.vipCallers});
    }
    case actionTypes.SET_REPORT_FILES: {
      return({...state, reportFiles: action.payload.reportFiles});
    }
    case actionTypes.SET_PURE_CHAT_START_TIME: {
      return({...state, pureChatStartTime: action.payload.pureChatStartTime});
    }
    case actionTypes.SET_PURE_CHAT_END_TIME: {
      return({...state, pureChatEndTime: action.payload.pureChatEndTime});
    }
    case actionTypes.SET_UNBLOCK_NUMBER_STATE: {
      return {
        ...state,
        confirmUnblockNumber: action.payload.confirmUnblockNumber,
        unblockAccountId: action.payload.unblockAccountId,
        unblockPhoneNumber: action.payload.unblockPhoneNumber,
      };
    }
    case actionTypes.SET_CALL_HANDLING_DATA: {
      return { ...state, callHandlingData: action.payload.callHandlingData };
    }
    case actionTypes.SET_PHONE_NUMBERS: {
      return { ...state, phoneNumbers: action.payload.phoneNumbers };
    }
    case actionTypes.SET_CALL_FORM: {
      return { ...state, callForm: action.payload.callForm };
    }
    case actionTypes.SET_CALL_FORM_LOADING: {
      return { ...state, callFormLoading: action.payload.loading };
    }
    case actionTypes.SET_AI_ACTIONS: {
      return { ...state, aiActions: action.payload.aiActions };
    }
    case actionTypes.SET_AI_ACTIONS_LOADING: {
      return { ...state, aiActionsLoading: action.payload.loading };
    }
    case actionTypes.SET_WARM_TRANSFER_ENABLED: {
      return { ...state, warmTransferEnabled: action.payload.warmTransferEnabled };
    }
    default: {
      return(state);
    }
  }  
}
